import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import systematic from '../../../config/systematic';
import arrayString from '../../../utilsTs/baseLib/arrayString';

const EditComponent = (props: any) => {
    const { editMode, defaultService } = props;
    const apiId = 'appDocument';
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [appVersionData, setAppVersionData] = useState<any>();
    const [appDocumentData, setAppDocumentData] = useState<any>();
    const [id, setId] = useState<string>();

    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (res?.success === true) {
                const { id, appVersionId } = res.data;
                setId(id);
                getAppDocumentList(appVersionId);
            }
        })

        fetchApi.GET(defaultService,
            {
                apiId: 'appVersion',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setAppVersionData(res.data);
                }
            })
    }, []);

    const getAppDocumentList = (appVersionId: string) => {
        fetchApi.GET(defaultService,
            {
                apiId: 'appDocument',
                apiExtend: 'showList',
                apiData: {
                    appVersionId
                }
            }).then(res => {
                if (res.success) {
                    const currentAppDocumentId = form.getFieldValue('id');
                    setAppDocumentData(arrayString.rmoveItem.byKey(res.data, currentAppDocumentId));
                } else {
                    setAppDocumentData([]);
                }
            })
    };

    const extendProps: WebEditUniversalProps = {
        ...props,
        apiId,
        displayOptions: {
            width: 1380
        },
        dateOptions: {
            columnNames: ['releaseDate']
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={6}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="ID"
                                    name="id">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="版本"
                                    name="appVersionId"
                                    rules={[{ required: true, message: '请选择版本!' }]}>
                                    <Select
                                        showSearch
                                        placeholder="版本"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        onChange={(e) => {
                                            getAppDocumentList(e);
                                        }}>
                                        {getList.general(appVersionData, {
                                            setItemNameFun: (item) => {
                                                const { id, versionName, app } = item;
                                                return { id, name: `${versionName}【${app?.name}】` }
                                            }
                                        })}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="上级"
                                    name="parentId"
                                    tooltip='上级主题'>
                                    <Select
                                        showSearch
                                        placeholder="上级主题"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(appDocumentData, {
                                            itemName: 'title'
                                        })}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="主题"
                                    name="title"
                                    rules={[{ required: true, message: '主题!' }]}>
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    label="排序"
                                    name="sorting">
                                    <InputNumber style={{ width: 50 }} />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    label="状态"
                                    name="isUse"
                                    valuePropName="checked"
                                    initialValue={true}>
                                    < Switch checked={true}
                                        checkedChildren="启用"
                                        unCheckedChildren="关闭" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="备注"
                                    name="remarks">
                                    < Input.TextArea autoSize={{ minRows: 2, maxRows: 10 }} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={18}>
                        <Form.Item
                            label=""
                            name="content">
                            <WangeditorV5ForAntD
                                key={id}
                                id={`${apiId}${id}`}
                                title='内容'
                                displayMode="editor"
                                defaultService={systematic.bmService}
                                style={{ height: 500 }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;